import React from 'react';
import PropTypes from 'prop-types';
import Panel from './Panel';
import ItemAgendamento from './ItemAgendamento';
import { Collapse, IconComp, ArrowDown, ArrowUp } from './styles';

const AgendamentoCollapse = ({ children, ...props }) => (
  <Collapse
    {...props}
    expandIcon={({ isActive }) => (
      <IconComp component={isActive ? ArrowUp : ArrowDown} />
    )}
  >
    {children}
  </Collapse>
);

AgendamentoCollapse.propTypes = {
  children: PropTypes.node.isRequired,
};

export { AgendamentoCollapse, Panel, ItemAgendamento };
